import { IInlineTabOptions } from './InlineTabsDefinitions';

interface IInlineTabProps extends IInlineTabOptions {}

// eslint-disable-next-line react/jsx-no-useless-fragment
const InlineTab: React.FC<IInlineTabProps> = (props: IInlineTabProps) => <>{props.children}</>;

export default InlineTab;
